module.exports = __webpack_public_path__ + "img/arrow-down-to-square.7f4843d2.svg";